import React, { useEffect, useState } from "react";
import QuickLinks from "../Components/QuickLinks/QuickLinks.js"
import personIcon from "../../../../assets/images/personIcon.svg";
import suppliesIcon from "../../../../assets/images/suppliesIcon.svg";
import offersIcon from "../../../../assets/images/offersIcon.svg";
import orderIcon from "../../../../assets/images/orderIcon.svg";
import paymentIcon from "../../../../assets/images/paymentIcon.svg";
import keyActionIcon from "../../../../assets/images/keyActions.svg";
import quickLinksIcon from "../../../../assets/images/quickLinksIcon.svg";
import printerIcon from "../../../../assets/images/printerIcon.svg";
import shoppingIcon from "../../../../assets/images/shoppingIcon.svg";
import recyclingIcon from "../../../../assets/images/recyclingIcon.svg";
import faqsIcon from "../../../../assets/images/faqsIcon.svg";
import printerIconWhite from "../../../../assets/images/printerIconWhite.svg";
import personIconWhite from "../../../../assets/images/personIconWhite.svg";
import orderWhite from "../../../../assets/images/orderWhite.svg";
import SectionHeader from "../Components/SectionHeader/SectionHeader.js";
import MoreCardOneImg from "../../../../assets/images/MoreCardOneImg.png";
import referFriend from "../../../../assets/images/Ink-recycle.jpg";
import inspiredCard from "../../../../assets/images/Creative-centre.jpg";
import moreCardsIcon from "../../../../assets/images/moreCardsIcon.svg";
import promoImg from "../../../../assets/images/promoImg.png";
import Cards from "../Components/Cards/Cards.js";
import HeaderComponent from "../../../../components/shared/header/HeaderComponent/HeaderComponent.js";
import { FetchMyAccount } from "../../../../actions/Dashboard";
import "./Dashboard.css"
import MoreLinks from "../Components/MoreLinks/MoreLinks.js";
import PromotionCards from "../Components/PromotionCards/PromotionCards.js";
import { routePath } from "../../../../constants/Routes.js";
import SmartSavings from "../../SmartSavings/SmartSavings.js";
import { useDispatch, useSelector } from 'react-redux';
import { getLocalSessionData, getFeatureSwitchByKey, getUserSessionData, getUserDataByKey } from '../../../../utils/Authentication/handleUserSession';
import { LOCALSESSIONDATAKEYS, featureSwitchName, SUSTAINABILITY_FOR_ITALY } from '../../../../constants/AppConstants';
import { getCountryCode } from '../../../../utils/Internationalization/handleAppInternationalization';
import { ENVSettings } from '../../../../constants/ENVSettings';
import { onUpdateUserProfile } from "../../../Account/MyAccount/MyAccount";
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { getRecycleForFreeWithBrotherLink, getExploreBrotherDevicesLink, getNeedHelpLink } from '../../../../constants/AppMethod';
import i18next from "i18next";
import { UserEnrolledDevicesServiceInit } from "../../../../store/UserEnrolledDevices/UserEnrolledDevicesSlice.js";
import { isEnrollmentBrotherPlus } from "../../../../constants/AppMethod";
import { ManageSubscriptionResetState } from "../../../../actions/MyAccount.js";
import PlannedMaintenance from "../../../../components/PlannedMaintenance/PlannedMaintenance.js";

const Dashboard = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [headerText, setHeaderText] = useState();
    const { t } = useTranslation(["translation"]);
    const fetchedMyAccount = useSelector((state) => state.FetchMyAccount);
    const userId = getUserSessionData('UserId');
    const getUserPromoCodeResponse = useSelector((state) => state.BROTHERPLUS.getUserPromoCode);
    const deviceModel = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_MODEL);
    const countryCode = getCountryCode();
    const languageCode = getLocalSessionData(LOCALSESSIONDATAKEYS.ECOPROWEBSIGNUPLANGCODE);
    const serialnumber = getLocalSessionData(LOCALSESSIONDATAKEYS.SERIAL_NUMBER);
    const isEnrollmentBPlus = isEnrollmentBrotherPlus();
    const isBrotherPlusFeatureSwitchEnabled = getFeatureSwitchByKey(featureSwitchName.BROTHER_PLUS);
    const {
        userDeviceList_success
    } = useSelector(state => state.ROOTREDUCER_RTK.GetUserEnrolledDevicesService);

    useEffect(() => {
        let timeoutId;
        if (getUserPromoCodeResponse?.success && getUserPromoCodeResponse?.userPromoCode?.promoCode) {
            const promoCode = getUserPromoCodeResponse?.userPromoCode?.promoCode;
            const baseurl = ENVSettings.BROTHER_STORE_BASE_URL;

            timeoutId = setTimeout(() => {
                const newTabUrl = `${baseurl}?model=${deviceModel}&country=${countryCode}&lang=${languageCode}&sn=${serialnumber}&coupon=${promoCode}`;
                window.open(newTabUrl, '_blank');
            }, 3000);
        }

        return () => {
            clearTimeout(timeoutId)
        }
    }, [getUserPromoCodeResponse, countryCode, languageCode, deviceModel, serialnumber]);

    useEffect(() => {
        if (userDeviceList_success) {
            dispatch(FetchMyAccount(userId));
        }
    }, [dispatch, userDeviceList_success, userId]);

    const goToPaymentEdit = () => {
        dispatch(ManageSubscriptionResetState());
        history.push({
            pathname: routePath.EDIT_PAYMENT, state: {
                'accountClicked': 'paymentDetails', data: fetchedMyAccount
            }
        });
    }
    let recycleForFreeWithBrotherLink = getRecycleForFreeWithBrotherLink();
    let exploreBrotherDevicesLink = getExploreBrotherDevicesLink();
    let needHelpLink = getNeedHelpLink();

    const handleBuySuppliesQuickLinks = () => {
        window.open(exploreBrotherDevicesLink);
    }

    const getUserDisplayName = () => {
        return `${getUserDataByKey('firstName', 'personal_details')} ${getUserDataByKey('lastName', 'personal_details')}`
    };

    useEffect(() => {
        const userName = getUserDisplayName();
        setHeaderText(i18next.t('CONNECT_DASHBOARD.WELCOME_TITLE', { userName }));

        if (!userDeviceList_success) {
            dispatch(UserEnrolledDevicesServiceInit());
        }
    }, [t, dispatch, userDeviceList_success]);

    return (
        <div class="customer-dashboard-container">
            <div className="customer-dashboard-content-wrapper">
                <div className="header-container">
                    <HeaderComponent title={headerText} description={t('CONNECT_DASHBOARD.WELCOME_DESCRIPTION')}> </HeaderComponent>
                </div>
                <PlannedMaintenance/>
                {(isBrotherPlusFeatureSwitchEnabled) ? <SmartSavings variant="dashboard"></SmartSavings> : null}
                <div className="cards-display-container" >
                    <Cards title={t('CONNECT_DASHBOARD.CARDS.DEVICES.TITLE')} classNameStyle="devices-style" cardIconSrc={printerIconWhite} description={t('CONNECT_DASHBOARD.CARDS.DEVICES.DESCRIPTION')} link={routePath.MY_DEVICES} ></Cards>
                    <Cards title={t('CONNECT_DASHBOARD.CARDS.ACCOUNT.TITLE')} classNameStyle="account-style" cardIconSrc={personIconWhite} description={t('CONNECT_DASHBOARD.CARDS.ACCOUNT.DESCRIPTION')} link={routePath.MY_ACCOUNT}></Cards>
                    {(!isEnrollmentBPlus) &&
                        <Cards title={t('CONNECT_DASHBOARD.CARDS.ORDERS.TITLE')} classNameStyle="order-style" cardIconSrc={orderWhite} description={t('CONNECT_DASHBOARD.CARDS.ORDERS.DESCRIPTION')} link={routePath.ORDERS}></Cards>
                    }
                </div>
                <div className="key-actions-container">
                    <SectionHeader imageSrc={keyActionIcon} title={t('CONNECT_DASHBOARD.KEY_ACTIONS.TITLE')} />
                    <div className="action-items-container">
                        <QuickLinks icon={personIcon} text={t('CONNECT_DASHBOARD.KEY_ACTIONS.UPDATE_MY_PERSONAL_DETAILS')} click={onUpdateUserProfile} ></QuickLinks>
                        <QuickLinks icon={suppliesIcon} text={t('CONNECT_DASHBOARD.KEY_ACTIONS.BUY_SUPPLIES')} click={handleBuySuppliesQuickLinks} ></QuickLinks>
                        <QuickLinks icon={offersIcon} text={t('CONNECT_DASHBOARD.KEY_ACTIONS.VIEW_OFFERS')} link={routePath.NOTIFICATION_CENTER} ></QuickLinks>
                        {(!isEnrollmentBPlus) &&
                            <>
                                <QuickLinks icon={orderIcon} text={t('CONNECT_DASHBOARD.KEY_ACTIONS.VIEW_MY_RECENT_ORDERS')} link={routePath.ORDERS} ></QuickLinks>
                                <QuickLinks icon={paymentIcon} text={t('CONNECT_DASHBOARD.KEY_ACTIONS.UPDATE_PAYMENT_METHODS')} click={goToPaymentEdit} ></QuickLinks>
                            </>
                        }
                    </div>
                </div>
                <div className="quick-links-container">
                    <SectionHeader imageSrc={quickLinksIcon} title={t('CONNECT_DASHBOARD.QUICK_LINKS.TITLE')} />
                    <div className="action-items-container">
                        <QuickLinks icon={printerIcon} text={t('CONNECT_DASHBOARD.QUICK_LINKS.DEVICE_SUPPORT')} classNameStyle="quick-link-styles" showOpenInNewTabIcon={true} link={needHelpLink} ></QuickLinks>
                        <QuickLinks icon={shoppingIcon} text={t('CONNECT_DASHBOARD.QUICK_LINKS.BROTHER_ONLINE_SHOP')} classNameStyle="quick-link-styles" showOpenInNewTabIcon={true} link={exploreBrotherDevicesLink} ></QuickLinks>
                        {( countryCode === "IT" ) ? <QuickLinks icon={recyclingIcon} text={t('CONNECT_DASHBOARD.QUICK_LINKS.SUSTAINABILITY')} classNameStyle="quick-link-styles" showOpenInNewTabIcon={true} link={SUSTAINABILITY_FOR_ITALY} ></QuickLinks> : <QuickLinks icon={recyclingIcon} text={t('CONNECT_DASHBOARD.QUICK_LINKS.RECYCLING')} classNameStyle="quick-link-styles" showOpenInNewTabIcon={true} link={recycleForFreeWithBrotherLink} ></QuickLinks>}
                        <QuickLinks icon={faqsIcon} text={t('CONNECT_DASHBOARD.QUICK_LINKS.FAQS')} classNameStyle="quick-link-styles" showOpenInNewTabIcon={true} link={needHelpLink}></QuickLinks>
                    </div>
                </div>
                <div className="more-cards-container">
                    <SectionHeader imageSrc={moreCardsIcon} title={t('CONNECT_DASHBOARD.MORE.TITLE')} />
                    <div className="more-links">
                        <MoreLinks imageSrc={MoreCardOneImg} cardTitle={t('CONNECT_DASHBOARD.MORE.MORE_LINKS.TILE_1.TITLE')} cardDescription={t('CONNECT_DASHBOARD.MORE.MORE_LINKS.TILE_1.DESCRIPTION')} link={exploreBrotherDevicesLink} response={getUserPromoCodeResponse} ></MoreLinks>
                        <MoreLinks imageSrc={referFriend} cardTitle={t('CONNECT_DASHBOARD.MORE.MORE_LINKS.TILE_2.TITLE')} cardDescription={t('CONNECT_DASHBOARD.MORE.MORE_LINKS.TILE_2.DESCRIPTION')} link={recycleForFreeWithBrotherLink}></MoreLinks>
                        <MoreLinks imageSrc={inspiredCard} cardTitle={t('CONNECT_DASHBOARD.MORE.MORE_LINKS.TILE_3.TITLE')} cardDescription={t('CONNECT_DASHBOARD.MORE.MORE_LINKS.TILE_3.DESCRIPTION')} link="https://www.creativecenter.brother/" ></MoreLinks>
                    </div>
                </div>
                <div className="promo-card-container">
                    <PromotionCards
                        imageSrc={promoImg}
                        heading={t('CONNECT_DASHBOARD.PROMOTION_CARDS.HEADING')}
                        title={t('CONNECT_DASHBOARD.PROMOTION_CARDS.TITLE')}
                        description={t('CONNECT_DASHBOARD.PROMOTION_CARDS.DESCRIPTION')}
                    ></PromotionCards>
                </div>
            </div>
        </div>
    )
}

export default Dashboard;